function Calendar() {
  return (
    <>
      <h1 style={{ margin: "0 auto" }}>Calendar</h1>
    </>
  );
}

export default Calendar;
